import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import Helmet from 'react-helmet';

import Home from './components/home';
import Profile from './containers/myProfile';
import Error from './components/error';
import {getMessage} from './utils/i18n';

class Routes extends Component {

    render() {
        return (
            <div className="foBody">
                <Helmet>
                    <title>{getMessage('app.name')}</title>
                </Helmet>
                <Switch>
                    <Route path="/myprofile" exact component={Profile} />
                    <Route path="/" component={Home}/>
                    <Route component={Error}/>
                </Switch>
            </div>
        );
    }

}

export default Routes;


// WEBPACK FOOTER //
// ./src/app/routes.js